export default __webpack_public_path__ + "static/media/talk.e846c7ab.png";